var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"index-con"},[_c('div',{staticClass:"big-title"},[_c('span',[_vm._v(_vm._s(_vm.$t("hotelbigtitle")))])]),_vm._v(" "),_c('div',{staticClass:"small-title"},[_vm._v(_vm._s(_vm.$t("hoteltext")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f421f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotel.vue
// module id = null
// module chunks = 